import { render, staticRenderFns } from "./RosterProfessional.vue?vue&type=template&id=e3596a62&scoped=true"
import script from "./RosterProfessional.vue?vue&type=script&lang=js"
export * from "./RosterProfessional.vue?vue&type=script&lang=js"
import style0 from "./RosterProfessional.vue?vue&type=style&index=0&id=e3596a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3596a62",
  null
  
)

export default component.exports